import { Card, Skeleton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import CustomTable from "../common/Table";
import { nexusHotelColumns } from "./constant";
import NexusHeader from "./NexusHeader";
import HTTP from "../../services/httpService";
import { SettingContext } from "../../routes";
import "./Nexus.css";

const NexusHotel = () => {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { rabbitQueue } = useContext(SettingContext);
    const [showSkeleton, setShowSkeleton] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageLimit, setCurrentPageLimit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tablePaylod, setTablePaylod] = useState({
        page: 0,
        limit: 10,
        staff_id,
        sorting: 1,
        sort_by: "",
    });

    async function fetchNexusHotelsWithPage(payload) {
        try {
            const hotelRes = await HTTP("nexus/getNexusHotels", payload);
            if (hotelRes.success) {
                setTableData(hotelRes.data);
                setTotalRecords(hotelRes.total);
                setShowSkeleton(false);
            }
        } catch (error) {
            setShowSkeleton(false);
            console.log("error in fetching Hotels", error);
        }
    }

    useEffect(() => {
        fetchNexusHotelsWithPage(tablePaylod);
    }, []);

    function handlePageChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        let tempPayload = tablePaylod;
        tempPayload.page = current - 1;
        tempPayload.limit = pageSize;
        if (order !== undefined) {
            tempPayload.sorting = order === "ascend" ? 1 : 2;
            tempPayload.sort_by = field;
        }
        setCurrentPage(current);
        setCurrentPageLimit(pageSize);
        fetchNexusHotelsWithPage(tempPayload);
        setTablePaylod({ ...tempPayload });
    }

    function updateHotelList() {
        let tempData = tableData;
        if (rabbitQueue && rabbitQueue?.flag === 101) {
            if (rabbitQueue?.route_to_calling_dashboard) {
                setTableData((prevState) => {
                    let isExist = prevState.some(
                        (item) => item.id === rabbitQueue.hotel_id,
                    );
                    if (!isExist) {
                        return [...prevState, rabbitQueue.hotel];
                    } else return prevState;
                });
            } else {
                tempData = tempData.filter(
                    (item) => item.id !== rabbitQueue?.hotel_id,
                );
                setTableData([...tempData]);
            }
        }
    }

    useEffect(() => {
        if (rabbitQueue) {
            updateHotelList();
        }
    }, [rabbitQueue]);

    return (
        <Card className="dashboard-container">
            <NexusHeader showBackButton={true} isHotelFilter={false}  withTime={false}/>
            <Card className="box-shadow margin-10">
                {!showSkeleton ? (
                    <div className="nexus-hotel-list-wrapper">
                        <CustomTable
                            columns={nexusHotelColumns}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handlePageChange}
                            rowKey="id"
                            className="nexus-hotel-table"
                            currentPage={currentPage}
                            currentPageLimit={currentPageLimit}
                            isScroll
                        />
                    </div>
                ) : (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                )}
            </Card>
        </Card>
    );
};

export default NexusHotel;
